import { backendUrlToDisplayUsername } from './BrandDetails.utils'

const FACEBOOK_TYPE: string = 'FACEBOOK'
const INSTAGRAM_TYPE: string = 'INSTAGRAM'
const TWITTER_TYPE: string = 'TWITTER'

type AccountMedia = {
  id: string
  mediaType: string
  url: string
  __typename: string
}
type SocialMediaAccount = {
  socialMediaType: string
  url: string
  __typename: string
}
type Profile = {
  accountMedia: AccountMedia
  logoId: string
  logoUrl: string
  ipadPhotoId: string
  ipadPhotoUrl: string
  productLineIds: string[]
  wholesaleMin: number
  wholesaleMax: number
  retailMin: number
  retailMax: number
  customUrlHandle: string
  websiteUrl: string
  socialMediaAccounts: SocialMediaAccount[]
  yearEstablished: number
  description: string
}
/**
 * DragDropImg shows its upload dropzone while `isEmpty(imgFile)`, and a
 * `{ id: null, url: null }` object is not empty. An image the brand never set
 * has to stay undefined so the block renders the dropzone instead of an <img>
 * with no src.
 */
const toImage = (id?: string, url?: string) =>
  id || url ? { id, url } : undefined

export const formatProfile = (profile: Profile) => ({
  accountMedia: profile?.accountMedia,
  logo: toImage(profile?.logoId, profile?.logoUrl),
  ipadPhoto: toImage(profile?.ipadPhotoId, profile?.ipadPhotoUrl),
  productLineIds: profile?.productLineIds,
  wholesaleMin: profile?.wholesaleMin,
  wholesaleMax: profile?.wholesaleMax,
  retailMin: profile?.retailMin,
  retailMax: profile?.retailMax,
  customUrlHandle: profile?.customUrlHandle,
  websiteUrl: profile?.websiteUrl,
  facebookLink:
    profile?.socialMediaAccounts?.find(
      (socialMedia: SocialMediaAccount) =>
        socialMedia?.socialMediaType === FACEBOOK_TYPE,
    )?.url || '',
  instagramHandle: backendUrlToDisplayUsername(
    'instagram',
    profile?.socialMediaAccounts?.find(
      (socialMedia: SocialMediaAccount) =>
        socialMedia?.socialMediaType === INSTAGRAM_TYPE,
    )?.url,
  ),
  twitterHandle: backendUrlToDisplayUsername(
    'twitter',
    profile?.socialMediaAccounts?.find(
      (socialMedia: SocialMediaAccount) =>
        socialMedia?.socialMediaType === TWITTER_TYPE,
    )?.url,
  ),
  yearEstablished: profile?.yearEstablished,
  description: profile?.description,
})
